import { MAX_COMMANDS } from '../core/constants';

export const CommandPhase = { Resolution: 0, Lifecycle: 1, EndOfStep: 2 } as const;
export type CommandPhaseId = (typeof CommandPhase)[keyof typeof CommandPhase];
export const CommandKind = {
  KillSlime: 0,
  SpawnDrop: 1,
  DespawnDrop: 2,
  DespawnSlime: 3,
  EndLevel: 4,
  SpawnSlime: 5,
} as const;
export type CommandKindId = (typeof CommandKind)[keyof typeof CommandKind];

export class CommandQueue {
  readonly kind = new Uint8Array(MAX_COMMANDS);
  readonly source = new Int16Array(MAX_COMMANDS);
  readonly target = new Int16Array(MAX_COMMANDS);
  readonly definition = new Uint8Array(MAX_COMMANDS);
  readonly x = new Float32Array(MAX_COMMANDS);
  readonly y = new Float32Array(MAX_COMMANDS);
  readonly a = new Float32Array(MAX_COMMANDS);
  readonly b = new Float32Array(MAX_COMMANDS);
  count = 0;

  push(kind: CommandKindId, source = -1, target = -1, definition = 0, x = 0, y = 0, a = 0, b = 0): void {
    if (this.count >= MAX_COMMANDS) throw new Error('CommandQueue capacity exceeded');
    const index = this.count++;
    this.kind[index] = kind;
    this.source[index] = source;
    this.target[index] = target;
    this.definition[index] = definition;
    this.x[index] = x;
    this.y[index] = y;
    this.a[index] = a;
    this.b[index] = b;
  }

  clear(): void { this.count = 0; }
}

export class CommandBuffer {
  readonly resolution = new CommandQueue();
  readonly lifecycle = new CommandQueue();
  readonly endOfStep = new CommandQueue();
  queue(phase: CommandPhaseId): CommandQueue {
    if (phase === CommandPhase.Resolution) return this.resolution;
    if (phase === CommandPhase.Lifecycle) return this.lifecycle;
    return this.endOfStep;
  }
  clear(): void {
    this.resolution.clear();
    this.lifecycle.clear();
    this.endOfStep.clear();
  }
}
